const TransactionsService = {
  getTransactions: async (payload) => {
    const params = Object.keys(payload).map(key => (payload[key] !== '' ? `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}` : null), []).filter(Boolean).join('&');
    const { data, headers } = await ovpFetch(`/transactions?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };

    const { link } = headers;

    let total = 0;
    if (headers['total-count']) {
      total = headers['total-count'];
    }

    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    return {
      transactions: data,
      pagination,
      total,
    };
  },
  exportTransactions: async (payload) => {
    const params = Object.keys(payload).map(key => (payload[key] !== '' ? `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}` : null), []).filter(Boolean).join('&');
    const { data } = await ovpFetch(`/transactions/csv?${params}`, {
      iLikeItRaw: true,
    });
    return data;
  },
  /**
   * @param {String} id
   * @return {Object}
   */
  getTransaction: async (id) => {
    const { data } = await ovpFetch(`/transactions/${id}`);
    return data;
  },
  getTransactionTicket: async (id) => {
    const { data } = await ovpFetch(`/pay/transactions/${id}/ticket`);
    return data;
  },
  /**
   * @param {String} id
   */
  refundTransaction: async (id) => {
    await ovpFetch(`/transactions/${id}/refund`, { method: 'POST', iLikeItRaw: true, body: JSON.stringify({}) });
    return true;
  },
};

// eslint-disable-next-line
export { TransactionsService };
